import { Tab, TabProps } from '@mui/material'
import { CounterBadge, Label } from './TabWithCounter.styles'

interface TabWithCounterProps extends Omit<TabProps, 'label'> {
  label: string
  count?: number
}

const TabWithCounter = ({ label, count, ...props }: TabWithCounterProps) => (
  <Tab
    {...props}
    label={
      <Label>
        {label}
        {count !== undefined && <CounterBadge>{count}</CounterBadge>}
      </Label>
    }
  />
)

export default TabWithCounter
